import { render, staticRenderFns } from "./journals.vue?vue&type=template&id=f0c26fc4&scoped=true&"
import script from "./journals.vue?vue&type=script&lang=js&"
export * from "./journals.vue?vue&type=script&lang=js&"
import style0 from "./journals.vue?vue&type=style&index=0&id=f0c26fc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c26fc4",
  null
  
)

export default component.exports